import React from 'react'
import { useNavigate } from 'react-router'
import { ListGroup } from 'react-bootstrap'
import { startsWith } from 'lodash'
import FontAwesomeIcon from '@severed-links/common.font-awesome-icon'
import * as styles from './SeasonSchedule.scss'

import PlayerTeamListItem from '../PlayerTeamListItem'

const SeasonSchedule = ({ seasonName = '', teamName = '', schedule = [], week = 0 }) => {

    const navigate = useNavigate()
    const getMatchupLink = s => `/football/regular-season/match-up/${s.seasonName}/week/${s.week}/game/${s.game}/${(teamName || '').toLowerCase()}-vs-${(s.oppTeamName || '').toLowerCase()}`

    const sched = schedule
    return (
        <section className={styles.container}>
            <div className={styles.heading}>
                <div>
                    <div className={styles.eyebrow}>{seasonName}</div>
                    <h3>Season schedule</h3>
                </div>
                <div className={styles.record}>{sched && sched.filter(s => startsWith(s.displayResult, 'Won')).length}-{sched && sched.filter(s => startsWith(s.displayResult, 'Lost')).length}</div>
            </div>
            <ListGroup className={styles.list}>
            {sched && sched.map(s => 
                <PlayerTeamListItem key={`season-schedule-${seasonName}-${s.week}-${s.oppId}`} 
                    className={startsWith(s.displayResult, 'Won') ? styles.win : startsWith(s.displayResult, 'Lost') ? styles.loss : ''}
                    size='sm'
                    miniHeader={<div>Week {s.week}</div>}
                    teamName={s.oppTeamName} teamNameRaw={s.oppTeamName}
                    teamId={s.oppId}
                    right={<div className={styles.result} onClick={e => e.stopPropagation()}>
                        <div onClick={() => navigate(getMatchupLink(s))}>
                        {s.displayResult}
                        {' '}
                        {startsWith(s.displayResult, 'Won') ? <FontAwesomeIcon name='check' fixedWidth /> : null}
                        {startsWith(s.displayResult, 'Lost') ? <FontAwesomeIcon name='times' fixedWidth /> : null}
                        </div>
                    </div>}
                    avatarUrl={s.oppAvatarUrl} />
            )}
            {!sched || sched.length === 0 ? <ListGroup.Item>No matchups located.</ListGroup.Item> : null}
            </ListGroup>
        </section>
    )
}

export default SeasonSchedule
